import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static targets = ['dialog', 'title', 'message', 'cancelButton', 'confirmButton']
  static values = {
    title: String,
    confirm: String
  }

  connect() {
    this.confirmAction = this.confirmAction.bind(this)
    Turbo.config.forms.confirm = this.confirmAction
  }

  disconnect() {
    if (Turbo.config.forms.confirm === this.confirmAction) Turbo.config.forms.confirm = undefined
    this.finish(false)
  }

  confirmAction(message, form, submitter) {
    if (this.resolveConfirmation) return Promise.resolve(false)
    if (typeof this.dialogTarget.showModal !== 'function') return Promise.resolve(window.confirm(message))

    this.dialogTarget.dataset.tone = form?.dataset.turboConfirmTone || 'danger'
    this.titleTarget.textContent = form?.dataset.turboConfirmTitle || this.titleValue
    this.messageTarget.textContent = message
    this.confirmButtonTarget.textContent =
      form?.dataset.turboConfirmButton || this.submitterLabel(submitter) || this.confirmValue
    this.dialogTarget.returnValue = ''

    const confirmation = new Promise((resolve) => {
      this.resolveConfirmation = resolve
    })

    this.dialogTarget.showModal()
    this.cancelButtonTarget.focus()

    return confirmation
  }

  close() {
    this.finish(this.dialogTarget.returnValue === 'confirm')
  }

  dismissOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close('cancel')
  }

  submitterLabel(submitter) {
    if (!submitter) return null

    return submitter.value?.trim() || submitter.textContent?.trim()
  }

  finish(confirmed) {
    if (!this.resolveConfirmation) return

    const resolve = this.resolveConfirmation
    this.resolveConfirmation = null
    resolve(confirmed)
  }
}
